import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import { useI18n } from "@/context/I18nContext";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { t } = useI18n();
  const TOPBAR = [t("topbar.1"), t("topbar.2"), t("topbar.3")];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-navy text-white">
      <div className="relative z-50 bg-navy-elevated/60 border-b border-white/5" data-testid="top-info-bar">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-9 items-center justify-center gap-6 text-[11px] sm:text-xs text-slate-400">
            {TOPBAR.map((t, i) => (
              <span key={i} className={i > 0 ? "hidden sm:inline-flex items-center gap-6" : "inline-flex items-center gap-6"}>
                {i > 0 && <span className="h-1 w-1 rounded-full bg-cyanx/60" />}
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
      <PublicHeader />
      <main className="pt-16">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
